export default __webpack_public_path__ + "static/media/promocionAlarma2.775e8369.png";